export default "./images/ED75.jpg";